import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.JobPage.title',
    defaultMessage: 'Job Page',
  },
})
